import { Component, OnInit } from '@angular/core';

import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';


import * as firebase from 'firebase/app';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['../login/login.component.css']
})
export class SignupComponent implements OnInit {

  signupForm: FormGroup;
  isAgreementTicked: any;

  constructor(
    private _formBuilder: FormBuilder,
    private _globalService: GlobalService
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.signupForm = this._formBuilder.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]],
    });
  }

  onSignup() {
    this._globalService.global_loader = true;
    const data = this.signupForm.value;
    this._globalService.domain = this._globalService.getDomain(data.email);
    this._globalService.signup(data.email, data.password)
      .then((res) => {
        // console.log('signup', res);
        this._globalService.sendVerificationEmail();
        // this.onRegisterNewUser(res);

        firebase.auth().currentUser.updateProfile({
          displayName: (this.signupForm.value.name).toLowerCase(),
          photoURL: ''
        }).then(function () {

        }).catch(function (error) {

        });

      })
      .catch((err) => {
        // console.log('error signup: ' + err);
        this._globalService.global_loader = false;
        this._globalService.openSnackBar(err, 'Dismiss');
      });
  }

  onRegisterNewUser(res) {
    const data = this.signupForm.value;
    const userdata = {
      authentication_id: res.uid,
      meta: {
        email: data.email,
        name: (data.name).toLowerCase(),
        mobile: '',
        pictureURL: '',
        pictureURLThumbnail: '',
        orgid: this._globalService.domain
      },
      emailVerified: false,
      online: true,
      theme: null,
      threads: null
    };

    const messagetoSave = Object.assign({}, userdata);
    const datasave = {};
    datasave[this._globalService.root_path + '/' +
      this._globalService.domain + '/users/' + userdata.authentication_id] = messagetoSave;


    this._globalService.firebaseUpdate(datasave)
      .then((resp) => {
        // console.log(resp);
        this._globalService.global_loader = false;
      })
      .catch((err) => {
        // console.log('error: ' + err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/signup/signup.component.ts